import React, { Component } from 'react'
import { css } from 'emotion'
import { CFView, Text } from 'components'
import { MEDIA_QUERY } from 'cf-web/src/styles'

class PrimaryButtonView extends Component {
  render() {
    const { className, disabled, label } = this.props
    const classNames = css(
      disabled ? styles.disabled : styles.button,
      className
    )
    return (
      <CFView center className={classNames}>
        <Text content h4 dark bold>
          {label}
        </Text>
      </CFView>
    )
  }
}

const styles = {
  button: css({
    paddingLeft: '6rem',
    paddingRight: '6rem',
    height: '5rem',
    background: 'rgba(255,255,255,0.25)',
    border: '3px solid #000',
    borderRadius: '0.8rem',
    cursor: 'pointer',
    transition: 'all .2s',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.3)',
    },
    [MEDIA_QUERY.SM]: {
      paddingLeft: '4rem',
      paddingRight: '4rem',
    },
  }),
  disabled: css({
    paddingLeft: '6rem',
    paddingRight: '6rem',
    height: '5rem',
    background: 'rgba(255,255,255,0.4)',
    border: '3px solid rgba(0,0,0,0.5)',
    borderRadius: '0.8rem',
    cursor: 'pointer',
    [MEDIA_QUERY.SM]: {
      paddingLeft: '4rem',
      paddingRight: '4rem',
    },
  }),
}

export default PrimaryButtonView
